var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthScore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:none;stroke:#A977F9;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:#C924A4;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 512,
    height: 512,
    xlinkHref: "C:\\\\\\\\Users\\\\\\\\monos\\\\\\\\Downloads\\\\\\\\bar-graph-with-a-cross.png",
    transform: "matrix(0.1687 0 0 0.1687 7.2579 6.8835)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 13.5,
    y1: 43.6,
    x2: 54,
    y2: 9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "44,8 54.7,8 54.7,17.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.9,47.7H52.8c-0.7,0-1.3-0.6-1.3-1.3V22.1c0-0.7,0.6-1.3,1.3-1.3h14.1c0.7,0,1.3,0.6,1.3,1.3v24.2 C68.3,47.1,67.7,47.7,66.9,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.2,72.7H36.1c-0.7,0-1.3-0.6-1.3-1.3V38c0-0.7,0.6-1.3,1.3-1.3h14.1c0.7,0,1.3,0.6,1.3,1.3v33.4 C51.5,72.1,50.9,72.7,50.2,72.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.4,72.7H19.3c-0.7,0-1.3-0.6-1.3-1.3V51.4c0-0.7,0.6-1.3,1.3-1.3h14.1c0.7,0,1.3,0.6,1.3,1.3v19.9 C34.7,72.1,34.1,72.7,33.4,72.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.5,52c0,0,18.2-11.1,43.1,0c0.1,0.2,1.3,0.4,0.9,2.7C86.2,57,84.2,78.2,65.3,91c0,0.1-1.8,0.9-3.3,0 c-2.3-1.3-17.4-10.5-20.6-36.3C41.4,55.2,40.9,52.8,42.5,52z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "59.2,55.6 68.3,55.6 68.3,62.7 75.7,62.7 75.7,71.5 68.3,71.5 68.3,78.9 59.2,78.9 59.2,72.2  51.2,72.2 51.5,62.7 59.2,62.6  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthScore);
export default __webpack_public_path__ + "static/media/health-score.24389abce60966f5084cbba339a8d3a8.svg";
export { ForwardRef as ReactComponent };